import { ComplexEnum } from '.'
import { NamedComplexEnumItem } from './NamedComplexEnumItem'

export abstract class NamedComplexEnum<
  Typename extends string,
  ItemType extends NamedComplexEnumItem<ID, Name>,
  Name extends string,
  ID extends Lowercase<string>
> extends ComplexEnum<Typename, ItemType, ID> {
  /**
   * the name of the associated {@link ItemType}
   */
  get names() {
    return this.map(({ name }) => name)
  }
  /**
   * attempts to find the first value where the {@link name} matches the item's
   * {@link NamedComplexEnumItem.name|name}
   *
   * @param name the name to search with
   */
  fromName = (name: string) => {
    return this.find((value) => value.name === name)
  }
  /**
   * finds the first value where the {@link name} matches the item's
   * {@link NamedComplexEnumItem.name|name}
   *
   * @param name the name to search with
   * @throws if no value can be found with the name
   */
  fromNameOrFail = (name: string) => {
    return this.orFail(this.fromName(name), name)
  }
}
